'use es6';

/* eslint no-restricted-globals: ['error', 'Set', 'WeakMap', 'WeakSet'] */
// In the interest of fixing linting issues for all of IPEUI, ^^^ this override allows us to use
// the global Map object for this file. See https://git.hubteam.com/HubSpot/eslint-hubspot-dev/pull/2 for discussion.
// tldr; IE11 has incomplete Map support (though we don't run into it here, with the limited get / set usages).
import IPEUIBackend from 'react-dnd-ipeui-backend';
import { DragDropContext } from 'react-dnd-compat';

// React DND should only pay attention to elements we have specifically tagged as something
// react-dnd should work on, so as to not interfere with TinyMCE.
// https://github.com/react-dnd/react-dnd-html5-backend/issues/7#issuecomment-262267786
const isValidTarget = target => {
  while (target && target.hasAttribute) {
    if (target.hasAttribute('data-hs-dragdrop')) {
      return true;
    }
    target = target.parentNode;
  }
  return null;
};
const ModifiedBackend = (...args) => {
  const instance = new IPEUIBackend(...args);
  instance.bodyClassNameWhenDragging = 'hs-dnd-cursor__grabbing';
  const listeners = ['handleTopDragStart', 'handleTopDragStartCapture', 'handleTopDragEndCapture', 'handleTopDragEnter', 'handleTopDragEnterCapture', 'handleTopDragLeaveCapture', 'handleTopDragOver', 'handleTopDragOverCapture', 'handleTopDrop', 'handleTopDropCapture'];
  const validTargetCache = new Map();
  listeners.forEach(name => {
    const original = instance[name];
    instance[name] = (e, ...extraArgs) => {
      // Check the Map cache for this element to see if it should be
      // handled by react-dnd
      const cacheValue = validTargetCache.get(e.target);
      if (cacheValue === true) {
        original(e, ...extraArgs);
        // If this is the handleTopDragEndCapture event, clear the cache,
        // because this drag interaction is done (and we don't know if the DOM
        // will change before we drag again)
        if (name === 'handleTopDragEndCapture') {
          validTargetCache.clear();
        }
      } else if (typeof cacheValue === 'undefined') {
        // Cache miss, walk the DOM to see if this element should be controlled by react-dnd
        if (isValidTarget(e.target)) {
          validTargetCache.set(e.target, true);
          original(e, ...extraArgs);
        } else {
          validTargetCache.set(e.target, false);
        }
      }
    };
  });
  return instance;
};

// Decorate root elements with this
export default DragDropContext(ModifiedBackend);